import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/manual/i18n/scope";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../../api-spec";

@Component({
    selector: "app-task-update-task-data-api-manual",
    templateUrl: "../../../api-spec.html",
    styleUrls: ["../../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)],
})
export class TaskUpdateTaskDataApiManualComponent extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel>{
            name: this.translation.t("specs.updateTaskScoreAndStatus"),
            description: this.translation.t("specs.updateTaskScoreAndStatusDescription"),
            httpMethod: "POST",
            path: "/taskdata/v1/tasks/{guid}",

            parameters: [
                {
                    name: "guid",
                    description: this.translation.t("parameters.updateTaskScoreAndStatusGuidDescription"),
                    in: "path",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "score",
                    description: this.translation.t("parameters.taskScoreDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "1",
                },
                {
                    name: "submit",
                    description: this.translation.t("parameters.taskSubmitDescription"),
                    in: "body",
                    paramType: "boolean",
                    required: false,
                    example: "true",
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                },
            ],
        };
    }
}
